import React, { memo } from "react";
import ReadonlyField from "./ReadonlyField";
import { FIELD_COLORS } from "../constants";
import { LoanEligibilityResponse } from "../types";

interface EligibilityResultProps {
  data?: LoanEligibilityResponse;
  // const offers: LoanEligibilityResponse
}

const EligibilityResult: React.FC<EligibilityResultProps> = ({ data }) => {
  const { labelColor, valueColor, valueBgColor } = FIELD_COLORS;

  // Use provided data or fall back to mock data for development
  const eligibilityData = data;

  const dbr = eligibilityData?.EligibilityResult?.DbrResult;

  const toNumber = (v?: string | number | null) =>
    Number.isFinite(Number(v)) ? Number(v) : 0;

  // const getLast = (arr: any)  => Array.isArray(arr) && arr.length > 0 ? arr[arr.length - 1] : null;
  const getLast = <T,>(arr?: T[] | null): T | null =>
    Array.isArray(arr) && arr.length > 0 ? arr[arr.length - 1] : null;

  const lastOffer = getLast(eligibilityData?.offer);

  const lastInstallment = getLast(lastOffer?.Installments_list);
  const lastInstallmentPayment = toNumber(lastInstallment?.PAYMENT);

  const totalObligationSum =
    toNumber(dbr?.OFO_amt) +
    toNumber(dbr?.BMO_amt) +
    toNumber(dbr?.GMO_amt) +
    toNumber(dbr?.OMO_amt) +
    lastInstallmentPayment;

  const obligationPercentage =
    toNumber(dbr?.netIncome) > 0
      ? (totalObligationSum / toNumber(dbr?.netIncome)) * 100
      : 0;
  const obligationPercentageRounded = Number(obligationPercentage.toFixed(2));
  return (
    <div className="container mt-4">
      <div className="row">
        <ReadonlyField
          label="ID Number"
          value={eligibilityData?.order_id ?? "-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Decision Reason"
          value={eligibilityData?.decision_reason ?? "-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Credit Policy check"
          value={eligibilityData?.CreditPolicyCheck ? "Yes" : "No"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Simha Check"
          value={eligibilityData?.SimhaCheck ? "Yes" : "No"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Simah Score"
          value={
            eligibilityData?.EligibilityResult?.SimahVerificationResult
              ?.SimahScore ?? "-"
          }
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Net Income"
          value={dbr?.netIncome ?? "-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="EMI"
          value={dbr?.EMI ?? "-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="New Installment Amount"
          value={lastInstallment?.PAYMENT ?? "-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Total obligation (%)"
          value={obligationPercentageRounded ?? "-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Old net salary"
          value={"-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Old Salary Percentage"
          value={"-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Salary increment Percentage"
          value={"-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Simah Reference number"
          value={"-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Offer package ID"
          value={lastOffer?.packageID ?? "-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Offer Rate"
          value={lastOffer?.interest_rate ?? "-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Special Rate Reason"
          value={"-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
        <ReadonlyField
          label="Occupation"
          value={"-"}
          labelColor={labelColor}
          valueColor={valueColor}
          valueBgColor={valueBgColor}
        />
      </div>
    </div>
  );
};

export default memo(EligibilityResult);
